<template>
  <div :class="{ 'singleton-modals-style': isParticipantPortalField }">
    <v-dialog
      v-if="show"
      v-model="show"
      :max-width="maxWidth"
      :persistent="persistent"
      :content-class="
        contentClass
          ? 'singleton-modal singleton-modals-dialog-style ' + contentClass
          : 'singleton-modal singleton-modals-dialog-style'
      "
    >
      <v-card class="singleton-modals-card-style">
        <v-icon
          id="closeModalIconId"
          v-if="!hideXIcon"
          style="position: absolute; right: 10px; top: 5px"
          @click="alertDismissed(false)"
          class="singleton-modals-close-icon-style"
          data-id="90b8c92eefa8d9d571ef3be7786e4e3c"
          >fal fa-times</v-icon
        >

        <v-card-title
          id="modalTitleId"
          :class="{
            headline: !isParticipantPortalField,
            'singleton-modals-title-style': isParticipantPortalField,
          }"
          :style="'color: ' + $colors.penChecksDarkGray"
        >
          <div v-if="!isParticipantPortalField" style="word-break: keep-all">
            {{ title }}
          </div>
          <v-row
            v-if="isParticipantPortalField"
            class="singleton-modals-title-row-style"
            ><svg
              v-if="icon === 'info'"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 1.5C9.92329 1.5 7.89322 2.11581 6.16651 3.26957C4.43979 4.42332 3.09398 6.0632 2.29926 7.98182C1.50454 9.90045 1.2966 12.0116 1.70175 14.0484C2.10689 16.0852 3.10692 17.9562 4.57537 19.4246C6.04383 20.8931 7.91475 21.8931 9.95155 22.2982C11.9883 22.7034 14.0995 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.5 9.21523 21.3937 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5V1.5ZM12 6C12.2225 6 12.44 6.06598 12.625 6.1896C12.81 6.31321 12.9542 6.48891 13.0394 6.69448C13.1245 6.90005 13.1468 7.12625 13.1034 7.34448C13.06 7.56271 12.9528 7.76316 12.7955 7.9205C12.6382 8.07783 12.4377 8.18498 12.2195 8.22838C12.0012 8.27179 11.775 8.24951 11.5695 8.16436C11.3639 8.07922 11.1882 7.93502 11.0646 7.75002C10.941 7.56501 10.875 7.3475 10.875 7.125C10.875 6.82663 10.9935 6.54048 11.2045 6.3295C11.4155 6.11853 11.7016 6 12 6ZM15 18.0938H9V16.4062H11.1562V12.0938H9.75V10.4062H12.8437V16.4062H15V18.0938Z"
                fill="#0075DB"
              />
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M2.73804 17.9979C1.96611 19.3313 2.92823 21 4.46889 21H19.5311C21.0718 21 22.0339 19.3313 21.262 17.9979L13.7309 4.98965C12.9605 3.65908 11.0395 3.65908 10.2691 4.98965L2.73804 17.9979Z"
                fill="#101F48"
              />
              <path
                d="M2.73804 17.9979C1.96611 19.3313 2.92823 21 4.46889 21H19.5311C21.0718 21 22.0339 19.3313 21.262 17.9979L13.7309 4.98965C12.9605 3.65908 11.0395 3.65908 10.2691 4.98965L2.73804 17.9979ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V13Z"
                fill="#F3AF3D"
              />
            </svg>
            <span>{{ title }}</span>
          </v-row>
        </v-card-title>

        <v-card-text
          :class="{
            'py-0': !isParticipantPortalField,
            'singleton-modals-text-style': isParticipantPortalField,
          }"
        >
          <span v-html="text"></span>
        </v-card-text>

        <v-card-text v-if="showInputText" class="singleton-modals-input-style">
          <v-text-field
            :color="$colors.penChecksTeal"
            id="prompt-modal-input-value"
            data-id="6441c09d297ed1bec67fea95329d183a"
            autofocus
            :label="inputLabel"
            :error-messages="error"
            v-model="inputValue"
            v-on:keyup.enter="alertDismissed(true)"
            v-on:keyup.esc="alertDismissed(false)"
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="singleton-modals-actions-style">
          <v-spacer></v-spacer>
          <v-btn
            v-if="cancelButtonText && !isParticipantPortalField"
            :color="cancelButtonColor"
            id="cancelButtonId"
            text
            @click="alertDismissed(false)"
            data-id="194f459de5109c58b69701b8263e23ca"
          >
            {{ cancelButtonText }}
          </v-btn>
          <div
            v-if="cancelButtonText && isParticipantPortalField"
            class="singleton-modals-cancel-button-style"
          >
            <div>
              <a
                @click="alertDismissed(false)"
                data-id="9477d8b15a8bfe14b5f427b8dd06b3eb"
              >
                <span class="singleton-modals-cancel-button-text-style">{{
                  cancelButtonText
                }}</span>
              </a>
            </div>
          </div>

          <v-btn
            v-if="!isParticipantPortalField"
            :color="okayButtonColor"
            id="okButtonId"
            text
            @click="alertDismissed(true)"
            data-id="3831a46a9db23dcbb136676eed60cae9"
          >
            {{ okayButtonText }}
          </v-btn>
          <pc-button
            data-id="963ed8dac00bc7d04b7ce6a3d2c3bd9f"
            v-if="isParticipantPortalField"
            class="singleton-modals-ok-button-style"
            :color="okayButtonColor"
            :participant-portal="isParticipantPortalField"
            @click="alertDismissed(true)"
          >
            <div>
              <span class="singleton-modals-ok-button-text-style">{{
                okayButtonText
              }}</span>
            </div>
          </pc-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Singletons from "@/shared/plugins/singletons";
import $ from "jquery";

export default {
  components: {},

  data: () => ({
    show: false,
    title: null,
    text: null,
    showInputText: false,
    inputLabel: null,
    inputValue: "",
    okayButtonText: null,
    okayButtonColor: null,
    cancelButtonText: null,
    cancelButonColor: null,
    persistent: false,
    hideXIcon: false,
    callback: null,
    cancelCallback: null,
    error: null,
    maxWidth: null,
    isParticipantPortalField: false,
    icon: null,
    contentClass: null,
  }),

  methods: {
    /**
     * Show an alert, with a simple "ok" button.
     */
    showAlert: function (options, callback, cancelCallback) {
      if ($.type(options) === "string") options = { text: options };

      if (!$.isPlainObject(options)) options = {};

      this.show = true;
      this.error = null;
      this.title = options["title"] || null;
      this.text = options["text"] || null;

      this.persistent = options["persistent"] || false;
      this.hideXIcon = options["hideXIcon"] || false;

      this.showInputText = options["showInputText"] || false;
      this.inputValue = options["inputValue"] || null;
      this.inputLabel = options["inputLabel"] || null;

      this.okayButtonText = options["okayButtonText"] || "OK";
      this.okayButtonColor =
        options["okayButtonColor"] || this.$colors.penChecksTeal;

      this.cancelButtonText = options["cancelButtonText"] || null;
      this.cancelButtonColor =
        options["cancelButtonColor"] || this.$colors.penChecksTeal;
      this.callback = callback || null;
      this.cancelCallback = cancelCallback || null;

      this.maxWidth = options["maxWidth"] || 432;
      this.isParticipantPortalField =
        options["isParticipantPortalField"] || false;
      this.icon = options["icon"] || null;
      this.contentClass = options["contentClass"] || null;
    },
    alertDismissed: function (okayWasClicked) {
      if (
        okayWasClicked &&
        this.showInputText &&
        (!this.inputValue || this.inputValue.trim().length == 0)
      ) {
        this.error = "Please enter a value";
        return;
      }

      this.show = false;

      const callbackValue = this.showInputText ? this.inputValue : null;

      if (okayWasClicked && $.isFunction(this.callback))
        this.callback(callbackValue);

      if (!okayWasClicked && $.isFunction(this.cancelCallback))
        this.cancelCallback();
    },
    /**
     * Ask a yes\no question.  Will default to "Okay" and "Cancel" buttons.
     */
    showConfirm: function (options, callback, cancelCallback) {
      if ($.type(options) === "string") options = { text: options };

      this.showAlert(options, callback, cancelCallback);

      this.okayButtonText = options["okayButtonText"] || "Okay";
      this.cancelButtonText = options["cancelButtonText"] || "Cancel";
      this.showInputText = options["showInputText"] || false;
      this.persistent = "persistent" in options ? options["persistent"] : true;
      this.icon = options["icon"] || null;
      this.contentClass = options["contentClass"] || null;
    },
    /**
     * Prompts with a question, and a free form text box.  Has "Okay" and "Cancel" buttons.
     */
    showPrompt: function (options, callback, cancelCallback) {
      if ($.type(options) === "string") options = { text: options };

      this.showAlert(options, callback, cancelCallback);

      this.okayButtonText = options["okayButtonText"] || "Okay";
      this.cancelButtonText = options["cancelButtonText"] || "Cancel";
      this.showInputText = options["showInputText"] || true;
      this.persistent = options["persistent"] || true;
      this.icon = options["icon"] || null;
      this.contentClass = options["contentClass"] || null;
    },
    hideModal() {
      this.show = false;
    },
  },

  mounted: function () {
    Singletons.Events.$on("showAlert", this.showAlert.bind(this));
    Singletons.Events.$on("showConfirm", this.showConfirm.bind(this));
    Singletons.Events.$on("showPrompt", this.showPrompt.bind(this));
    Singletons.Events.$on("hideModal", this.hideModal.bind(this));
  },
};
</script>

<style lang="scss">
.singleton-modal {
  .v-card__title.headline {
    font-size: 18px !important;
    font-weight: normal !important;
  }
}

.singleton-modals-dialog-style {
  font-family: "Open Sans", sans-serif;

  .singleton-modals-card-style {
    .singleton-modals-title-style {
      margin: 0px;
      padding: 0px !important;

      .singleton-modals-title-row-style {
        margin: 0px;
        padding: 24px 32px 24px 32px !important;

        div {
          width: 3px;
          height: 24px;
          border-radius: 1px;
          background-color: $primary;
        }

        span {
          margin-top: -4px;
          margin-left: 12px !important;
          color: $neutral90;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    .singleton-modals-text-style {
      color: $neutral70 !important;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.25px;
      line-height: 20px;
      text-align: left;

      padding: 0px 32px 24px 32px !important;

      span {
        p {
          color: $neutral70 !important;
        }
      }
    }

    .singleton-modals-input-style {
    }

    .singleton-modals-actions-style {
      padding-bottom: 24px !important;

      .singleton-modals-cancel-button-style {
        margin-right: 24px;
        padding-left: 24px;
        padding-right: 24px;
        .singleton-modals-cancel-button-text-style {
          font-size: 14px;
          font-weight: 600;
          color: $neutral60;
        }
      }

      .singleton-modals-ok-button-style {
        margin-right: 16px;

        button {
          height: 40px !important;
          padding-left: 24px;
          padding-right: 24px;
          background-color: $primary;
          border-color: $primary !important;
          border-radius: 6px;

          span {
            padding-top: 10px;
            padding-bottom: 10px;

            div {
              .singleton-modals-ok-button-text-style {
                font-weight: 600;
                text-transform: none;
                width: fit-content;
              }
            }
          }
        }
      }
    }
  }
}
</style>
